export default "__VITE_ASSET__COmZqt0J__"